import { render, staticRenderFns } from "./UpgradePlan.vue?vue&type=template&id=16762006&"
import script from "./UpgradePlan.vue?vue&type=script&lang=js&"
export * from "./UpgradePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports